<h3 i18n>Master Settings</h3>
<small i18n>These settings are only available if you have special privileges.</small>
<hr>
<ng-content></ng-content>
